import { CameraType } from '@/features/user-settings';

export const isCameraCalibrated = ({
  camera,
  detectedSquareSize,
}: {
  camera: CameraType;
  detectedSquareSize: undefined | number;
}) => {
  return camera === CameraType.Lab && detectedSquareSize && detectedSquareSize > 0;
};
